// extracted by mini-css-extract-plugin
export default {"searchTooltipRebranding":"SearchTooltip__searchTooltipRebranding--2Kt9b"};